import React, { useState, useEffect } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";
import { Modal, Button, Form } from "react-bootstrap";
import Preloader from "../../shared/PreLoaders"; // Make sure you have a Preloader component

const ClosingBalance = ({ open, onClose }) => {
  const [vfcData, setVfcData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    vfcId: "",
    date: "",
    cash: "",
    bank: "",
    dateOfExecution: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const Api = process.env.REACT_APP_API;

  // Fetch VFC data
  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, Config);
        const data = response.data.vfcs;
        setVfcData(data);
      } catch (error) {
        console.log("Error fetching VFCs", error);
      }
      setLoading(false);
    };
    fetchVfc();
  }, [Api]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const config = Authorization();
      await axios.post(`${Api}/api/closing-balance`, formData, config);
      alert("Closing balance added!");
      onClose();
    } catch (error) {
      alert("Error: " + (error.response?.data?.error || error.message));
    }
    setSubmitting(false);
  };

  // Reset form when modal closes
  const handleClose = () => {
    setFormData({
      vfcId: "",
      date: "",
      cash: "",
      bank: "",
      dateOfExecution: "",
    });
    onClose();
  };

  if (!open) return null;

  return (
    <div>
      <Preloader loading={loading} />
      <Modal show onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Add Closing Balance</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formVfcId">
              <Form.Label>
                VFC Name<span className="required-asterisk">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                name="vfcId"
                value={formData.vfcId}
                onChange={handleChange}
                required
              >
                <option value="">Select VFC</option>
                {vfcData.map((vfc) => (
                  <option key={vfc._id} value={vfc._id}>
                    {vfc.vfcName}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formDate">
              <Form.Label>
                Date<span className="required-asterisk">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formCash">
              <Form.Label>
                Cash<span className="required-asterisk">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                name="cash"
                value={formData.cash}
                onChange={handleChange}
                required
                min="0"
              />
            </Form.Group>

            <Form.Group controlId="formBank">
              <Form.Label>
                Bank<span className="required-asterisk">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                name="bank"
                value={formData.bank}
                onChange={handleChange}
                required
                min="0"
              />
            </Form.Group>

            <Form.Group controlId="formDateOfExecution">
              <Form.Label>
                Date of Execution<span className="required-asterisk">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="dateOfExecution"
                value={formData.dateOfExecution}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button
              variant="outline-primary"
              type="submit"
              disabled={submitting}
            >
              {submitting ? "Saving..." : "Save"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ClosingBalance;
